export const SwapIcon = () => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 11.625C0 5.20469 5.20469 0 11.625 0C18.0453 0 23.25 5.20469 23.25 11.625V12.375C23.25 18.7953 18.0453 24 11.625 24C5.20469 24 0 18.7953 0 12.375V11.625Z"
        fill="#77A77F"
      />
      <path
        d="M9.76191 10.1249C9.69808 9.29718 9.88934 8.46981 10.31 7.75412C10.7306 7.03844 11.3603 6.46878 12.1145 6.12183C12.8686 5.77488 13.711 5.6673 14.5281 5.81355C15.3453 5.95981 16.098 6.35289 16.685 6.93988C17.272 7.52688 17.6651 8.27961 17.8113 9.09675C17.9576 9.9139 17.85 10.7562 17.5031 11.5104C17.1561 12.2646 16.5864 12.8943 15.8708 13.3149C15.1551 13.7355 14.3277 13.9268 13.5 13.863"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17.875 15.125C17.875 15.6223 17.6775 16.0992 17.3258 16.4508C16.9742 16.8025 16.4973 17 16 17H14.75M14.75 17L16 15.75M14.75 17L16 18.25M5.375 8.875C5.375 8.37772 5.57254 7.90081 5.92417 7.54918C6.27581 7.19754 6.75272 7 7.25 7H8.5M8.5 7L7.25 8.25M8.5 7L7.25 5.75M9.4375 18.25C8.36006 18.25 7.32675 17.822 6.56488 17.0601C5.80301 16.2983 5.375 15.2649 5.375 14.1875C5.375 13.1101 5.80301 12.0767 6.56488 11.3149C7.32675 10.553 8.36006 10.125 9.4375 10.125C10.5149 10.125 11.5483 10.553 12.3101 11.3149C13.072 12.0767 13.5 13.1101 13.5 14.1875C13.5 15.2649 13.072 16.2983 12.3101 17.0601C11.5483 17.822 10.5149 18.25 9.4375 18.25Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}
